import React, {useEffect, useState} from 'react'
import ContentLoader, {List} from 'react-content-loader'
import {getStickerInfo, stickerDownloadURL} from "./state/stickerPageActions"
import {TEST_STICKER_INFO} from "./state/testStickerInfo"
import './stickerPullPage.scss'
import FallBackImage from '../../assets/images/fallback_ipacket_folder.png'
import PrintIcon from '../../assets/icons/printicon.js'
import TextDocIcon from '../../assets/icons/textdocicon.js'
import SinglePgDocIcon from '../../assets/icons/singlepgdocicon.js'
import MultiPgDocIcon from '../../assets/icons/multipgdocicon.js'

export default function StickerPage(props){
  const urlParams = new URLSearchParams(window.location.search);
  const jwt = urlParams.get('jwt')
  const tk = urlParams.get('token')

  const token = ()=>{
    if(tk){return tk}
    return(jwt)
  }

  const {id} = props
  const [stickerInfo, setStickerInfo] = useState(null)
  const [loading, setLoading] = useState(true)
  const [errorLoading, setErrorLoading] = useState(false)
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  const separateOptions = (options)=>{
    let separatedOptions = {
      standard_options:{},
      added_options:{},
    }
    for(let i = 0; i< options.length; i++){
      if(options[i].type === 'standard'){
        let key = 'NO_SECTION'
        if(options[i].section){
          key = options[i].section
        }
        if(separatedOptions.standard_options.hasOwnProperty(key)){
          separatedOptions.standard_options[key].push(options[i])
        }
        else{
          separatedOptions.standard_options[key] = [options[i]]
        }
      }
      else{
        let key = 'NO_SECTION'
        if(options[i].section){
          key = options[i].section
        }
        if(separatedOptions.added_options.hasOwnProperty(key)){
          separatedOptions.added_options[key].push(options[i])
        }
        else{
          separatedOptions.added_options[key] = [options[i]]
        }
      }
    }
    return separatedOptions
  }

  useEffect(()=>{
    getStickerInfo(id,token()).then((response)=>{
      // if(enableTest){
      //   return(TEST_STICKER_INFO[0])
      // }
      if(response.status===200){
          return response.json()
      }
      else{
        //TODO: Throw Sentry Error
        setErrorLoading(true)
        setLoading(false)
      }
    }).then(res=>{
      if(res){
        setStickerInfo({...res,...separateOptions(res.options)})
      }
      setLoading(false)
    })
  },[])

  const togglePrintDropdown = () => {
    setDropdownOpen(!isDropdownOpen);
  };

  const handlePrintButtonClick = (pageType) => {
    if(pageType == 'multi') {
      // Set the font size just a little smaller for multi page
      const fontSize = parseFloat(getComputedStyle(document.querySelector('.sticker-body')).fontSize);
      document.querySelector('.sticker-body').style.fontSize = `${fontSize * .85}px`;
      document.querySelector('.sticker-footer').style.fontSize = `${fontSize * .85}px`;

      window.print()

      // reset styles to initial
      document.querySelector('.sticker-body').style.fontSize = '13px';
      document.querySelector('.sticker-footer').style.fontSize = '.75em';

    } else if (pageType == 'single') {
      // check for height of document and if needing more columns in Added Options section
      const checkPrintMedia = () => {
          const stickerBodyContentHeight = document.querySelector('.sticker-added-options').offsetHeight + document.querySelector('.sticker-footer').offsetHeight;
          const contentDetailsPrintAreaHeight = 600 - document.querySelector('.sticker-header').offsetHeight - 10

          if (stickerBodyContentHeight > contentDetailsPrintAreaHeight) {
            // Content exceeds one page, adjust into 2 columns
            document.querySelector('.sticker-added-options-item-detail').style.columnCount = '2';
            // Now check if it needs to be 3 columns instead of 2
            if (!stickerInfo.standard_options) {
              document.querySelector('.sticker-added-options').classList.add('third-column')
              if(document.querySelector('.third-column').offsetHeight + document.querySelector('.sticker-footer').offsetHeight > contentDetailsPrintAreaHeight) {
                document.querySelector('.sticker-added-options-item-detail').style.columnCount = '3';
              }
            }
          }
      };

      const scaleFontSizeForPrinting = () => {
        const pageSize = {
          width: 800,
          height: 600,
        };

        // Calculate the scale factor for font size
        const scaleFactor = Math.min(
          pageSize.width / document.body.clientWidth,
          pageSize.height / document.body.clientHeight
        );

        // Set the font size dynamically
        const fontSize = parseFloat(getComputedStyle(document.querySelector('.sticker-body')).fontSize);
        document.querySelector('.sticker-body').style.fontSize = `${fontSize * scaleFactor}px`;
        document.querySelector('.sticker-footer').style.fontSize = `${fontSize * scaleFactor}px`;
      };

      // Call fxn from above to change content to columns if longer than one page
      checkPrintMedia();
      // Call fxn from above to alter font size if needed
      scaleFontSizeForPrinting();

      window.print()

      // reset styles to initial
      document.querySelector('.sticker-body').style.fontSize = '13px';
      document.querySelector('.sticker-footer').style.fontSize = '.75em';
      document.querySelector('.sticker-added-options-item-detail').style.columnCount = '1';
    }
  };

  const handleDownloadTextOnlyDoc = () => {
    window.open(stickerDownloadURL(id,token()), '_blank');
  };

  const VehicleDetailsItem = (props)=>{
    return(
        <div className="sticker-vehicle-details-item">
          <div className="sticker-vehicle-details-item-title">
            {props.title}
          </div>
          <div className="sticker-vehicle-details-item-info">
            {props.detail}
          </div>
        </div>
    )
  }
  const Sticker = ()=>{
    let enNumFormatter = Intl.NumberFormat('en-US')
    const skinStyleString = `
      body .sticker-header .sticker-suggested-price-container .sticker-suggested-price{
        background-color: ${stickerInfo.metadata.primary_make_color};
        color: ${stickerInfo.metadata.secondary_make_color};
      }
      .sticker-header .sticker-suggested-price-container .sticker-suggested-price:before{
        border-color: transparent transparent ${stickerInfo.metadata.primary_make_color};
      }
      body .sticker-body .sticker-added-options-container .sticker-added-options{
        background-color: ${stickerInfo.metadata.primary_make_color+'1A'};
      }
      body .sticker-page-controls .sticker-page-controls-print:hover{
        background-color: ${stickerInfo.metadata.primary_make_color};
      }
      .sticker-page-controls .sticker-page-controls-print:hover svg{
        fill: ${stickerInfo.metadata.secondary_make_color};
      }
      @media print {
        @page {
          margin: 0.5cm; /* Set margins for the printed page */
          size: landscape; /* Force landscape printing */
        }
      }
    `
    return(
      <div className='sticker-container'>
        <style>
          {skinStyleString}
        </style>
        <div className="sticker">
          <div className="sticker-header">
            <div className="sticker-logo-container">
              {stickerInfo.generic_details.logo?
                <img className="sticker-logo" src={stickerInfo.generic_details.logo}/>
                :
                <img className="sticker-logo" src={FallBackImage}/>
              }
            </div>
            <div className="sticker-vehicle-details-container">
              <div className="sticker-vehicle-details">
                <div className="sticker-vehicle-details-ymm">
                  {`${stickerInfo.generic_details.year} ${stickerInfo.generic_details.make} ${stickerInfo.generic_details.model?stickerInfo.generic_details.model:""}`}
                </div>
                <div className="sticker-vehicle-details-items">
                  {
                    stickerInfo.generic_details.vin?
                    <VehicleDetailsItem title="VIN" detail={stickerInfo.generic_details.vin}/>
                    :
                    <React.Fragment/>
                  }
                  {
                    stickerInfo.generic_details.trim?
                    <VehicleDetailsItem title="TRIM" detail={stickerInfo.generic_details.trim}/>
                    :
                    <React.Fragment/>
                  }
                  {
                    stickerInfo.generic_details.engine?
                    <VehicleDetailsItem title="ENGINE" detail={stickerInfo.generic_details.engine}/>
                    :
                    <React.Fragment/>
                  }
                  {
                    stickerInfo.generic_details.transmission?
                    <VehicleDetailsItem title="TRANSMISSION" detail={stickerInfo.generic_details.transmission}/>
                    :
                    <React.Fragment/>
                  }
                  {
                    stickerInfo.generic_details.drivetrain?
                    <VehicleDetailsItem title="DRIVETRAIN" detail={stickerInfo.generic_details.drivetrain}/>
                    :
                    <React.Fragment/>
                  }
                  {
                    stickerInfo.generic_details.interior_color?
                    <VehicleDetailsItem title="INTERIOR" detail={stickerInfo.generic_details.interior_color}/>
                    :
                    <React.Fragment/>
                  }
                  {
                    stickerInfo.generic_details.exterior_color?
                    <VehicleDetailsItem title="EXTERIOR" detail={stickerInfo.generic_details.exterior_color}/>
                    :
                    <React.Fragment/>
                  }
                </div>
              </div>
            </div>
            {(stickerInfo.pricing_details &&  stickerInfo.pricing_details.total) ?
              <div className="sticker-suggested-price-container">
                <div className="sticker-suggested-price-label">
                  {`TOTAL ${(stickerInfo.metadata && stickerInfo.metadata.oem_quality)?"SUGGESTED":"PREDICTED"} PRICE`}
                </div>
                <div className="sticker-suggested-price">
                  {`$${enNumFormatter.format(stickerInfo.pricing_details.total)}`}
                </div>
              </div>
              :
              <React.Fragment/>
            }
          </div>
          <div className="sticker-body">
            {stickerInfo.standard_options && Object.keys(stickerInfo.standard_options).length ?
              <div className="sticker-standard-options-container">
                <div className="sticker-standard-options">
                  <div className="sticker-standard-options-title">
                    STANDARD OPTIONS
                  </div>
                  {Object.keys(stickerInfo.standard_options).map(section=>{
                    return(
                      <React.Fragment key={section}>
                        {section==='NO_SECTION'?<React.Fragment/>:<div className="sticker-standard-options-section-title">{section}</div>}
                        <ul className="sticker-standard-options-items">
                          {
                            stickerInfo.standard_options[section].map(option=>{
                              return(
                                <li className="sticker-standard-options-item" key={option.description}>
                                    {`${option.code?option.code+' - ':''}${option.description?option.description:""}`}

                                    <ul>
                                      {option.sub_options && options.sub_options.map(sub_option=>{
                                        return(
                                          <li key={sub_option.description}>{`${sub_option.code?sub_option.code+' - ':''}${sub_option.description?sub_option.description:""}`}</li>
                                        )
                                      })}
                                    </ul>
                                </li>
                              )
                            })
                          }
                        </ul>
                      </React.Fragment>
                    )
                  })}
                </div>
              </div>
              :
              <React.Fragment/>
            }

            <div className="sticker-added-options-container">
              <div className="sticker-added-options">
                {stickerInfo.pricing_details && (stickerInfo.pricing_details.base) ?
                  <div className="sticker-added-options-base-suggested-price">
                    <div className="sticker-added-options-base-suggested-price-label">
                      BASE SUGGESTED PRICE
                    </div>
                    <div className="sticker-added-options-base-suggested-price-value">
                      {`$${enNumFormatter.format(stickerInfo.pricing_details.base)}`}
                    </div>
                  </div>
                  :<React.Fragment/>
                }
                <div className="sticker-added-options-items">
                  <div className="sticker-added-options-item">
                    <div className="sticker-added-options-item-label">
                      ADDED OPTIONS
                    </div>
                    <div className="sticker-added-options-item-detail">
                      {
                        Object.keys(stickerInfo.added_options).map(section=>{
                          return(
                            <React.Fragment key={section}>
                              {section==='NO_SECTION'?<React.Fragment/>:<div className="sticker-added-options-section-title">{section}</div>}
                              <ul>
                                {
                                  stickerInfo.added_options[section].map(option=>{
                                    return(

                                          <li className={`sticker-added-options-item-detail-li${option.price?" sticker-added-options-item-detail-li-has-price":""}`}key={option.description}>
                                            <div className="sticker-added-options-item-detail-desc">{`${option.code?option.code+' - ':''}${option.description?option.description:""}`}</div>
                                            <div className="sticker-added-options-item-detail-price">
                                              {option.price?
                                                <>{`${(Math.sign(option.price)<0) ? '-':''}$${enNumFormatter.format(Math.abs(option.price))}`}</>
                                                :
                                                <React.Fragment/>
                                              }
                                            </div>
                                            {(option.sub_options && option.sub_options.length)?
                                                <ul>
                                                  {option.sub_options.map(sub_option=>{
                                                    return(
                                                      <li>
                                                        <div className="sticker-added-options-item-detail-desc">{`${sub_option.code?sub_option.code + ' - ':''}${sub_option.description?sub_option.description:""}`}</div>
                                                        {sub_option.price?
                                                          <div className="sticker-added-options-item-detail-price">{`${(Math.sign(sub_option.price)<0) ? '-':''}$${enNumFormatter.format(Math.abs(sub_option.price))}`}</div>
                                                          :
                                                          <React.Fragment/>
                                                        }
                                                      </li>
                                                    )
                                                  })}
                                                </ul>
                                              :
                                              <React.Fragment/>
                                            }
                                          </li>

                                    )
                                  })

                                }
                              </ul>
                            </React.Fragment>
                          )
                        })
                      }
                  </div>
                  </div>
                </div>
                {stickerInfo.pricing_details && (stickerInfo.pricing_details.base || stickerInfo.pricing_details.total || stickerInfo.pricing_details.details)?
                  <div className="sticker-added-options-price-totals">
                    <div className="sticker-added-options-price-totals-label">
                      PRICE DETAILS
                    </div>
                    {(stickerInfo.pricing_details && stickerInfo.pricing_details.details)?
                      <div className="sticker-added-options-price-totals-items">
                        {stickerInfo.pricing_details.details.map(detail=>{
                          return(
                            <div className="sticker-added-options-price-totals-item" key={detail.label}>
                              <div className="sticker-added-options-price-totals-item-label">
                                {detail.label}
                              </div>
                              <div className="sticker-added-options-price-totals-item-price">
                                {`${(Math.sign(detail.price)<0) ? '-':''}$${enNumFormatter.format(Math.abs(detail.price))}`}
                              </div>
                            </div>
                          )
                        })}
                      </div>
                      :
                      <React.Fragment/>
                    }
                    {stickerInfo.pricing_details.freight?
                      <div className="sticker-added-options-freight-price">
                        <div className="sticker-added-options-freight-price-label">
                          {`FREIGHT`}
                        </div>
                        <div className="sticker-added-options-freight-price-value">
                          {`$${enNumFormatter.format(stickerInfo.pricing_details.freight)}`}
                        </div>
                      </div>
                      :
                      <React.Fragment/>
                    }
                    <div className="sticker-added-options-total-suggested-price">
                      <div className="sticker-added-options-total-suggested-price-label">
                        {`TOTAL ${(stickerInfo.metadata && stickerInfo.metadata.oem_quality)?"SUGGESTED":"PREDICTED"} PRICE`}
                      </div>
                      <div className="sticker-added-options-total-suggested-price-value">
                        {`$${enNumFormatter.format(stickerInfo.pricing_details.total)}`}
                      </div>
                    </div>
                  </div>
                  :
                  <React.Fragment/>
                }
              </div>
              </div>

          </div>
          <div className="sticker-footer">
            {stickerInfo.metadata && stickerInfo.metadata.disclaimer}
          </div>
        {!(stickerInfo.metadata && stickerInfo.metadata.oem_quality)?
          <div className="sticker-overlay">
            PREDICTIVE DATA
          </div>
          :
          <React.Fragment/>
        }
        </div>
      </div>
    )
  }
  return(
    <div className="sticker-page-container">
      <div className="sticker-page">
        {(stickerInfo && !loading)?
          <>
            <div className="sticker-page-controls">
              <button onClick={togglePrintDropdown}>
              <PrintIcon/>
              </button>
              <div className="print-dropdown-container">
                <div className={`print-dropdown-content ${isDropdownOpen ? 'print-dropdown-visible' : ''}`}>
                  <button onClick={() => handlePrintButtonClick('single')}><SinglePgDocIcon /><span>Single Page</span></button>
                  <button onClick={() => handlePrintButtonClick('multi')}><MultiPgDocIcon /><span>Multi Page</span></button>
                  <button onClick={() => handleDownloadTextOnlyDoc()}><TextDocIcon /><span>Text Only</span></button>
                </div>
              </div>
            </div>
            <Sticker/>
          </>
          :
          <>
            {errorLoading?
              <div className="sticker-page-error">
                There was a problem loading this document
              </div>
              :
              <div className="sticker-page-loading">
                <div className='sticker-page-loading-mobile'>
                  <ContentLoader height={'100%'} width={'100%'}>
                    <rect x="50%" y="0" rx="5" ry="5" width="50%" height="50" />
                    <circle cx="50%" cy="170" r="100" />
                    <rect x="20%" y="290" rx="5" ry="5" width="60%" height="20" />
                    <rect x="10%" y="330" rx="5" ry="5" width="10%" height="20" />
                    <rect x="25%" y="330" rx="5" ry="5" width="65%" height="20" />
                    <rect x="10%" y="370" rx="5" ry="5" width="10%" height="20" />
                    <rect x="25%" y="370" rx="5" ry="5" width="60%" height="20" />
                    <rect x="10%" y="410" rx="5" ry="5" width="10%" height="20" />
                    <rect x="25%" y="410" rx="5" ry="5" width="65%" height="20" />
                    <rect x="5%" y="450" rx="5" ry="5" width="90%" height="5" />
                    <rect x="5%" y="470" rx="5" ry="5" width="90%" height="200" />
                    <circle cx="10%" cy="700" r="10" />
                    <rect x="15%" y="690" rx="5" ry="5" width="75%" height="20" />
                    <circle cx="10%" cy="740" r="10" />
                    <rect x="15%" y="730" rx="5" ry="5" width="70%" height="20" />
                    <circle cx="10%" cy="780" r="10" />
                    <rect x="15%" y="770" rx="5" ry="5" width="75%" height="20" />
                    <circle cx="10%" cy="820" r="10" />
                    <rect x="15%" y="810" rx="5" ry="5" width="70%" height="20" />
                  </ContentLoader>
                </div>
                <div className='sticker-page-loading-tablet'>
                  <ContentLoader height={'100%'} width={'100%'}>
                    <rect x="65%" y="0" rx="5" ry="5" width="45%" height="50" />
                    <circle cx="120" cy="100" r="100" />
                    <rect x="20" y="230" rx="5" ry="5" width="60%" height="20" />
                    <rect x="20" y="270" rx="5" ry="5" width="80" height="20" />
                    <rect x="120" y="270" rx="5" ry="5" width="30%" height="20" />
                    <rect x="20" y="310" rx="5" ry="5" width="80" height="20" />
                    <rect x="120" y="310" rx="5" ry="5" width="25%" height="20" />
                    <rect x="20" y="350" rx="5" ry="5" width="80" height="20" />
                    <rect x="120" y="350" rx="5" ry="5" width="30%" height="20" />
                    <rect x="3%" y="390" rx="5" ry="5" width="95%" height="5" />
                    <rect x="3%" y="410" rx="5" ry="5" width="95%" height="500" />
                    <circle cx="4%" cy="940" r="10" />
                    <rect x="6%" y="930" rx="5" ry="5" width="26%" height="20" />
                    <circle cx="37%" cy="940" r="10" />
                    <rect x="39%" y="930" rx="5" ry="5" width="22%" height="20" />
                    <circle cx="70%" cy="940" r="10" />
                    <rect x="72%" y="930" rx="5" ry="5" width="26%" height="20" />
                    <circle cx="4%" cy="980" r="10" />
                    <rect x="6%" y="970" rx="5" ry="5" width="22%" height="20" />
                    <circle cx="37%" cy="980" r="10" />
                    <rect x="39%" y="970" rx="5" ry="5" width="26%" height="20" />
                    <circle cx="70%" cy="980" r="10" />
                    <rect x="72%" y="970" rx="5" ry="5" width="22%" height="20" />
                    <circle cx="4%" cy="1020" r="10" />
                    <rect x="6%" y="1010" rx="5" ry="5" width="26%" height="20" />
                    <circle cx="37%" cy="1020" r="10" />
                    <rect x="39%" y="1010" rx="5" ry="5" width="22%" height="20" />
                    <circle cx="70%" cy="1020" r="10" />
                    <rect x="72%" y="1010" rx="5" ry="5" width="26%" height="20" />
                  </ContentLoader>
                </div>
                <div className='sticker-page-loading-desktop'>
                  <ContentLoader height={'100%'} width={'100%'}>
                    <rect x="70%" y="50" rx="5" ry="5" width="30%" height="90" />
                    <circle cx="10%" cy="100" r="100" />
                    <rect x="25%" y="30" rx="5" ry="5" width="40%" height="20" />
                    <rect x="25%" y="70" rx="5" ry="5" width="8%" height="20" />
                    <rect x="34%" y="70" rx="5" ry="5" width="25%" height="20" />
                    <rect x="25%" y="110" rx="5" ry="5" width="8%" height="20" />
                    <rect x="34%" y="110" rx="5" ry="5" width="25%" height="20" />
                    <rect x="25%" y="150" rx="5" ry="5" width="8%" height="20" />
                    <rect x="34%" y="150" rx="5" ry="5" width="25%" height="20" />
                    <rect x="1%" y="230" rx="5" ry="5" width="98%" height="5" />
                    <rect x="55%" y="260" rx="5" ry="5" width="45%" height="700" />
                    <circle cx="2%" cy="270" r="10" />
                    <rect x="4%" y="260" rx="5" ry="5" width="20%" height="20" />
                    <circle cx="2%" cy="310" r="10" />
                    <rect x="4%" y="300" rx="5" ry="5" width="18%" height="20" />
                    <circle cx="2%" cy="350" r="10" />
                    <rect x="4%" y="340" rx="5" ry="5" width="20%" height="20" />
                    <circle cx="2%" cy="390" r="10" />
                    <rect x="4%" y="380" rx="5" ry="5" width="18%" height="20" />
                    <circle cx="2%" cy="430" r="10" />
                    <rect x="4%" y="420" rx="5" ry="5" width="20%" height="20" />
                    <circle cx="2%" cy="470" r="10" />
                    <rect x="4%" y="460" rx="5" ry="5" width="18%" height="20" />
                    <circle cx="2%" cy="510" r="10" />
                    <rect x="4%" y="500" rx="5" ry="5" width="20%" height="20" />
                    <circle cx="2%" cy="550" r="10" />
                    <rect x="4%" y="540" rx="5" ry="5" width="18%" height="20" />
                    <circle cx="2%" cy="590" r="10" />
                    <rect x="4%" y="580" rx="5" ry="5" width="20%" height="20" />
                    <circle cx="2%" cy="630" r="10" />
                    <rect x="4%" y="620" rx="5" ry="5" width="18%" height="20" />
                    <circle cx="2%" cy="670" r="10" />
                    <rect x="4%" y="660" rx="5" ry="5" width="20%" height="20" />
                    <circle cx="2%" cy="710" r="10" />
                    <rect x="4%" y="700" rx="5" ry="5" width="18%" height="20" />
                    <circle cx="2%" cy="750" r="10" />
                    <rect x="4%" y="740" rx="5" ry="5" width="20%" height="20" />
                    <circle cx="2%" cy="790" r="10" />
                    <rect x="4%" y="780" rx="5" ry="5" width="18%" height="20" />
                    <circle cx="2%" cy="830" r="10" />
                    <rect x="4%" y="820" rx="5" ry="5" width="20%" height="20" />
                    <circle cx="2%" cy="870" r="10" />
                    <rect x="4%" y="860" rx="5" ry="5" width="18%" height="20" />
                    <circle cx="2%" cy="910" r="10" />
                    <rect x="4%" y="900" rx="5" ry="5" width="20%" height="20" />
                    <circle cx="2%" cy="950" r="10" />
                    <rect x="4%" y="940" rx="5" ry="5" width="18%" height="20" />
                    <circle cx="29%" cy="270" r="10" />
                    <rect x="31%" y="260" rx="5" ry="5" width="18%" height="20" />
                    <circle cx="29%" cy="270" r="10" />
                    <rect x="31%" y="260" rx="5" ry="5" width="18%" height="20" />
                    <circle cx="29%" cy="310" r="10" />
                    <rect x="31%" y="300" rx="5" ry="5" width="20%" height="20" />
                    <circle cx="29%" cy="350" r="10" />
                    <rect x="31%" y="340" rx="5" ry="5" width="18%" height="20" />
                    <circle cx="29%" cy="390" r="10" />
                    <rect x="31%" y="380" rx="5" ry="5" width="20%" height="20" />
                    <circle cx="29%" cy="430" r="10" />
                    <rect x="31%" y="420" rx="5" ry="5" width="18%" height="20" />
                    <circle cx="29%" cy="470" r="10" />
                    <rect x="31%" y="460" rx="5" ry="5" width="20%" height="20" />
                    <circle cx="29%" cy="510" r="10" />
                    <rect x="31%" y="500" rx="5" ry="5" width="18%" height="20" />
                    <circle cx="29%" cy="550" r="10" />
                    <rect x="31%" y="540" rx="5" ry="5" width="20%" height="20" />
                    <circle cx="29%" cy="590" r="10" />
                    <rect x="31%" y="580" rx="5" ry="5" width="18%" height="20" />
                    <circle cx="29%" cy="630" r="10" />
                    <rect x="31%" y="620" rx="5" ry="5" width="20%" height="20" />
                    <circle cx="29%" cy="670" r="10" />
                    <rect x="31%" y="660" rx="5" ry="5" width="18%" height="20" />
                    <circle cx="29%" cy="710" r="10" />
                    <rect x="31%" y="700" rx="5" ry="5" width="20%" height="20" />
                    <circle cx="29%" cy="750" r="10" />
                    <rect x="31%" y="740" rx="5" ry="5" width="18%" height="20" />
                    <circle cx="29%" cy="790" r="10" />
                    <rect x="31%" y="780" rx="5" ry="5" width="20%" height="20" />
                    <circle cx="29%" cy="830" r="10" />
                    <rect x="31%" y="820" rx="5" ry="5" width="18%" height="20" />
                    <circle cx="29%" cy="870" r="10" />
                    <rect x="31%" y="860" rx="5" ry="5" width="20%" height="20" />
                    <circle cx="29%" cy="910" r="10" />
                    <rect x="31%" y="900" rx="5" ry="5" width="18%" height="20" />
                    <circle cx="29%" cy="950" r="10" />
                    <rect x="31%" y="940" rx="5" ry="5" width="20%" height="20" />
                    <rect x="1%" y="990" rx="5" ry="5" width="98%" height="5" />
                    <rect x="30%" y="1020" rx="5" ry="5" width="40%" height="20" />
                  </ContentLoader>
                </div>
              </div>
            }
          </>
        }
      </div>
    </div>
  )
}
